(function($) {

  /**
   * This function helps to add a content block and/or a header in the middle of the MPP products.
   * 
   */

  Drupal.behaviors.contentBetweenProducts = {
    attach: function(context, settings) {
      $product_grid = $('ul.mpp__product-grid');
      //Since mobile and PC products list have different class names, add() is used here
      $product_list = $product_grid.find('li.mpp__product').add($product_grid.find('li.product-brief'));

      //As MPP products have various views like 2up,3up, and 5up, Products per row is calculated here based on <ul> and <li> width
      var products_per_row = parseInt($product_grid.width() / $product_list.width());

      $('.content_between_mpp_products_v1').each(function() {
        $this = $(this);
        //Check whether content block or html block exists
        if ($this.find('.content-block').length > 0 || $this.find('.html-block').length > 0) {
          var row_number = parseInt($this.attr('data-row-number'));
          if (!isNaN(row_number) && !isNaN(products_per_row)) {
            var li_number = ((row_number - 1) * products_per_row) - 1;
            $list_selector = $product_list.eq(li_number);
            //Creating <li> based on products per row to perserve the existing style.
            for (var i = 1; i <= products_per_row; i++) {
             var new_list = (i === 1) ? $('<li class="content_between_products products-per-row-' + products_per_row + '">').html($this.html()) : $('<li class="placeholder hidden">');
              $list_selector.after(new_list);
            }
          }
        }
      });
    }
  };

})(jQuery);
